<template>
    <span>
        &copy; {{ new Date().getFullYear() }}
        <b-link href="https://www.aar.org">
            Association of American Railroads
        </b-link>
    </span>
</template>

<script>
export default {
  name: 'CopyrightLink'
}
</script>
